import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import {
  GetUserInfoSuccess,
  SsoSuccess,
} from '../store/actions/auth.actions';
import * as fromApp from '../../shared/store/app.reducer';
import { AuthService } from './auth.service';
import { AuthService as Auth } from 'auth';
import { AppConfig } from '../../config/app-config';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    private store: Store<fromApp.AppState>,
    private auth: Auth,
    public router: Router,
    private authService: AuthService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    // Read auth state once (RxJS 6 style)
    const authState: any = await this.store.select('auth').pipe(take(1)).toPromise();
    let { userInfo, token } = authState || {};

    // Seed token from SSO service if missing
    if (!token && this.auth && (this.auth as any).token) {
      this.store.dispatch(new SsoSuccess({ token: (this.auth as any).token }));
      const refreshed: any = await this.store.select('auth').pipe(take(1)).toPromise();
      token = refreshed && refreshed.token;
    }

    // If user info already present, allow
    if (userInfo) {
      return true;
    }

    // Otherwise, fetch user info
    try {
      const resp = await this.authService.getUserInfo(token).pipe(take(1)).toPromise();
      this.store.dispatch(new GetUserInfoSuccess({ userInfo: resp }));
      return true;
    } catch (_error) {
      // No redirect; cancel navigation
      return false;
    }
  }

  // Replace the current history entry when sending to SSO
  redirectToSsoLogin = (_targetUrl: string) => {
    const currentUrl = window.location.href;
    const env = AppConfig.settings.apiServer.authGuard;
    const ssoUrl = env.loginUrl + encodeURIComponent(currentUrl);
    window.location.replace(ssoUrl);
    return 'redirect';
  };

  private getParameterValueByName(param: string, url: string): string {
    const matches = url.match(new RegExp(param + '=([^&]*)'));
    return matches ? matches[1] : '';
  }
}
